export default {
  'SimpleAvgRating.title': 'Average rating',
  'SimpleAvgRating.tooltipText':
    'The average rating is calculated based on the rating of all products in your account',
}
